import { createSelector } from 'reselect';
import map from 'lodash/map';
import { getLoadingSummary } from 'helpers/loadingStatusHelper';
import { formatChartDataV2 } from '../../../commonTrendHelpers';
import { apiCallStatus } from 'helpers/constants';


const getDateSelection = ({ overview }) => {
    return overview.dateSelection;
};

const getMultiChartPreselection = ({ operationalParameters }) => { // in the future this will be received from BE
    return operationalParameters.preselectedKPIs?.multi?.trend || [];
};

const getAvailableKPIs = ({ operationalParameters }) => {
    return operationalParameters.availableKPIs?.trend?.data;
};

const getTrendKPILoadingStatus = ({ operationalParameters }) => {
    return operationalParameters.availableKPIs?.trend.loadingStatus;
};

const getLoadingStatusForCharts = ({ operationalParameters }) => {
    const loadingStatuses = map(operationalParameters.charts?.multi?.trend, (trendChart) => {
        return trendChart.loadingStatus;
    });
    return getLoadingSummary(loadingStatuses) || apiCallStatus.LOADING;
};

const getMultiTrendData = ({ operationalParameters }) => {
    const multiChartData = formatChartDataV2(
        operationalParameters.charts?.multi?.trend || [],
        operationalParameters.availableKPIs?.trend?.data
    );
    return multiChartData;
};

const getUserLimits = ({ detailedInformationHeader }) => {
    return detailedInformationHeader.userLimits?.data?.visualAids;
};

const getUserLimitsLoadingStatus = ({ detailedInformationHeader }) => {
    return detailedInformationHeader.userLimits?.loadingStatus;
};

export const getModel = createSelector([
    getDateSelection,
    getAvailableKPIs,
    getMultiChartPreselection,
    getTrendKPILoadingStatus,
    getMultiTrendData,
    getUserLimits,
    getUserLimitsLoadingStatus,
    getLoadingStatusForCharts
],
    (
        dateSelection,
        availableKPIs,
        multiChartPreselection,
        trendKPILoadingStatus,
        multiChartData,
        userLimits,
        userLimitsLoadingStatus,
        loadingStatusForCharts
    ) => {
        return {
            dateSelection,
            availableKPIs,
            multiChartPreselection,
            trendKPILoadingStatus,
            multiChartData,
            userLimits,
            userLimitsLoadingStatus,
            loadingStatusForCharts
        };
    });


